import script from "./VModalMediaAssets.vue?vue&type=script&setup=true&lang=ts"
export * from "./VModalMediaAssets.vue?vue&type=script&setup=true&lang=ts"

import "./VModalMediaAssets.vue?vue&type=style&index=0&id=ebc4f68a&lang=css&scoped=true"
import "./VModalMediaAssets.vue?vue&type=style&index=1&id=ebc4f68a&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebc4f68a"]])

export default __exports__